<template>
    <transition name="panel">
        <div 
            v-if="show" class="warning_panel_wrapper" 
            :class="
                { 
                    page_margin: pageWarning, 
                    form_margin: formWarning 
                }"
            >
            <div class="text_section">
                <font-awesome-icon :icon="['fas', 'triangle-exclamation']" />&nbsp;
                <span v-if="expiredAccountWarning">
                    <span>{{ $t('warningPanel.expiredAccountInfo', { accountCount: expiredAccountsCount }) }}</span>
                    <i18n-t keypath="warningPanel.expiredAccountRedirectionInfo" tag="span">
                        <a href="#" class="expired_accounts_link" @click="showExpiredAccountsModal">{{ $t('warningPanel.click') }}</a>
                    </i18n-t>
                </span>
                <span v-else>{{ text }}</span>
            </div>
            <div class="close_button_section">
                <button
                    v-if="explainable"
                    type="button"
                    class="explain_button"
                    :disabled="explainLoading"
                    @click="explainError"
                >
                    <span class="icon material-icons explain_icon">auto_awesome</span>
                    {{ explainLoading ? $t('warningPanel.explaining') : $t('warningPanel.explain') }}
                </button>
                <span class="icon material-icons" @click="closeWarningModal">close</span>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: [
        "show",
        "text",
        "formWarning",
        "pageWarning",
        "explainable",
        "explainLoading",
        "expiredAccountsCount",
        "expiredAccountWarning"
    ],
    emits: [
        "explainError",
        "closeWarningModal",
        "showExpiredAccountsModal"
    ],
    methods: {
        closeWarningModal() {
            this.$emit("closeWarningModal");
        },
        showExpiredAccountsModal() {
            this.$emit("showExpiredAccountsModal");
        },
        explainError() {
            this.$emit("explainError");
        }
    }
}
</script>

<style scoped>
.warning_panel_wrapper {
    gap: 12px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 12px 18px;
    border-radius: 3px;
    align-items: center;
    justify-content: space-between;
    background-color: var(--sniffer-color-warning);
    border: 1px solid var(--sniffer-color-warning-border);
}

.text_section {
    min-width: 0;
    flex: 1 1 220px;
    overflow-wrap: anywhere;
}

.page_margin {
    margin: 18px 12px;
}

.form_margin {
    margin: 12px 0;
}

.expired_accounts_link {
    color: var(--sniffer-color-primary);
}

.text_section, .close_button_section span {
    color: var(--sniffer-color-warning-text);
}

.close_button_section {
    gap: 12px;
    display: flex;
    flex-shrink: 0;
    margin-left: auto;
    align-items: center;
}

.close_button_section span {
    cursor: pointer;
}

.explain_button {
    gap: 4px;
    display: flex;
    cursor: pointer;
    font-size: 13px;
    padding: 4px 4px;
    border-radius: 3px;
    white-space: nowrap;
    align-items: center;
    min-width: 130px;
    justify-content: center;
    color: var(--sniffer-color-warning-text);
    background-color: transparent;
    border: 1px solid var(--sniffer-color-warning-text);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.explain_button:disabled {
    cursor: default;
    opacity: 0.6;
}

.explain_icon {
    font-size: 16px;
}

.panel-leave-to {
    opacity: 0;
    transform: scale(0.8);
}

.panel-leave-active {
    transition: all 0.6s ease-in;
}
</style>